<template lang="pug">
.register-body
  .register-row
    .register-group
      .register-key
        span.key-name メッセージの返信可能期限
        span.validation-label 必須

      .register-value.radios
        label.register-radio-label
          input#type-0.register-radio-form(
            v-model="_value"
            name="send-message-reply-limit"
            type="radio"
            :value="0"
            v-validate="{ required: true }"
            data-vv-as="メッセージの返信可能期限")
          span.register-radio-text 制限なし
        label.register-radio-label
          input#type-1.register-radio-form(v-model="_value" name="send-message-reply-limit" type="radio" :value="7")
          span.register-radio-text 1週間
        label.register-radio-label
          input#type-2.register-radio-form(v-model="_value" name="send-message-reply-limit" type="radio" :value="14")
          span.register-radio-text 2週間
        label.register-radio-label
          input#type-3.register-radio-form(v-model="_value" name="send-message-reply-limit" type="radio" :value="21")
          span.register-radio-text 3週間
        label.register-radio-label
          input#type-4.register-radio-form(v-model="_value" name="send-message-reply-limit" type="radio" :value="28")
          span.register-radio-text 4週間
        label.register-radio-label
          input#type-5.register-radio-form(v-model="_value" name="send-message-reply-limit" type="radio" :value="35")
          span.register-radio-text 5週間

      .error-messages(v-for="error in errors.collect('send-message-reply-limit')")
        label.error-message {{ error }}
        br
</template>

<script lang="ts">
import { Component, Prop, Inject, Vue } from "vue-property-decorator";
import { Validator } from "vee-validate";

/**
 * ### 入力要素コンポーネント
 *
 * - 既存の入力画面のスタイルが適用される
 * - バリデーターは親コンポーネントのものをInjectionして使用する
 *   - そのため、親コンポーネントでveevalidateをnewしておく必要がある
 */
@Component
export default class FormInputSendMessageReplyLimit extends Vue {
  // 親コンポーネントのバリデーターをInjectionする
  @Inject("$validator") $validator!: Validator;

  /** 親コンポーネントでv-modelで指定した値 */
  @Prop({ required: true })
  value!: number;

  /** 子コンポーネントのv-modelでpropの値を指定してはいけないのでgetterにする */
  get _value(): number {
    return this.value;
  }

  /** 値が変更されたら親コンポーネントに値を渡す */
  set _value(newValue: number) {
    this.$emit("input", newValue);
    return;
  }
}
</script>

<style lang="scss" scoped>
// ラジオボタンは横幅に応じてラップする
.radios {
  flex-wrap: wrap;
}
</style>
